export const ENROLLMENTS_5_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_priority: 1,
    meta_status: true,
    meta_icon: "",
    meta_icon_alt: "",
    meta_field_1: "Duration",
    meta_field_2: "12 Months",
  },

  METADATA_TITLES: {
    metadata: "Key Points",
  },

  ENROLLMENTS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title (wrap highlight in { } e.g. About this {Programme})",
      value: "About this {Programme}",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "About this {Programme}",
      required: false,
      defaultValue: "About this {Programme}",
      rows: 2,
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Short paragraph describing the programme",
      required: false,
      defaultValue: "",
      rows: 4,
    },
    {
      fieldName: "cta_label",
      label: "Button label",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Apply Now",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "cta_url",
      label: "Button URL",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/path or https:// — used when 'Open lead popup' is off",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "open_in_new_tab",
      label: "Open link in new tab",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "enable_lead_popup",
      label: "Is CTA — open lead popup",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "On = lead capture popup instead of button URL",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "enable_lead_form",
      label: "Show lead form on the right",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "On = render the page's lead form beside the content (desktop) / as a CTA on mobile",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "background_color",
      label: "Section background color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_color",
      label: "Title color",
      value: "#0A0A0A",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#0A0A0A",
      required: false,
      defaultValue: "#0A0A0A",
    },
    {
      fieldName: "title_highlight_color",
      label: "Title highlight color (for {...} text)",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#DB5803",
      required: false,
      defaultValue: "#DB5803",
    },
    {
      fieldName: "description_color",
      label: "Description color",
      value: "#0A0A0A",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#0A0A0A",
      required: false,
      defaultValue: "#0A0A0A",
    },
    {
      fieldName: "body_text_color",
      label: "Key point label color (small text)",
      value: "#0A0A0A",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#0A0A0A",
      required: false,
      defaultValue: "#0A0A0A",
    },
    {
      fieldName: "accent_color",
      label: "Key point value color (bold text)",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#DB5803",
      required: false,
      defaultValue: "#DB5803",
    },
    {
      fieldName: "cta_background_color",
      label: "Button background",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#DB5803",
      required: false,
      defaultValue: "#DB5803",
    },
    {
      fieldName: "cta_text_color",
      label: "Button text color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Sort order (1, 2, 3…)",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show/Hide this key point",
      defaultValue: true,
    },
    {
      header: "Icon",
      fieldName: "meta_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload key point icon",
    },
    {
      header: "Icon alt text",
      fieldName: "meta_icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Icon alt text",
    },
    {
      header: "Label (small text)",
      fieldName: "meta_field_1",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Duration",
    },
    {
      header: "Value (bold text)",
      fieldName: "meta_field_2",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 12 Months",
    },
  ],
};
